import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import SortimentList from "./lists/SortimentList";
import SortimentForm from "./forms/SortimentForm";
import Button from "../form/Button";
import SelectorGrid from "../form/SelectorGrid/SelectorGrid";
import {ProductColumn} from "../../utils/formatters";

class SortimentEditor extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            editorHeader: this.props.values.name || "Új Sortiment felvitele"
        }
    }

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.setState({editorHeader: data.name});
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.setState({editorHeader: "Új Sortiment felvitele"});
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        return (
            <Fragment>
                <List
                    {...this.props}
                    theme="default"
                    header={"Sortimentek"}
                    footer={[
                        <Button key="0" color="default" onClick={ this.pristineForm }>
                            Új
                        </Button>
                    ]}
                >
                    <SortimentList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header={this.state.editorHeader}
                    footer={[
                        <Button key="0" disabled={ !this.props.dirty || this.props.isLoading } color="default" className="pull-right" onClick={ this.saveForm }>
                            Mentés
                        </Button>,
                        <Button key="1" disabled={!this.props.values[this.props.componentConfig.idfield] || this.props.isLoading}
                                color="danger"
                                className="pull-left"
                                onClick={this.props.deleteForm}>
                            Törlés
                        </Button>
                    ]}
                >
                    <SortimentForm {...this.props} />
                </Editor>
                {
                    this.props.values[this.props.componentConfig.idfield]
                    &&
                    <Box
                        theme="default"
                        header="Termékek"
                    >
                        <SelectorGrid
                            columns={{
                                "displayname": {
                                    ...ProductColumn("product_id"),
                                    width: 2,
                                }
                            }}
                            name={"items"}
                            listfieldlabel={"displayname"}
                            data={this.props.values}
                            componentConfig={this.props.componentConfig}
                            {...this.props.getFieldProps("items")}
                        />
                    </Box>
                }
                {
                    this.props.values[this.props.componentConfig.idfield]
                    &&
                    <Box
                        theme="default"
                        header="Eladási helyek"
                    >
                        <SelectorGrid
                            columns={{
                                "name": {header: 'Megnevezés', width: 2, sortable: true, filterable: true}
                            }}
                            name={"pos"}
                            listfieldlabel={"name"}
                            data={this.props.values}
                            componentConfig={this.props.componentConfig}
                            {...this.props.getFieldProps("pos")}
                        />
                    </Box>
                }
            </Fragment>
        );
    }
}

export default createEditor({componentName: "Sortiment", WrappedComponent: SortimentEditor});
